<template>
    <div>
      <Head title="Reports" />
      <h1 class="mb-8 text-3xl font-bold">User Report
            <downloadexcel
            :data="users"
            :fields="user_fields"
          >
          <v-btn large color="primary">Download <v-icon>mdi-download</v-icon></v-btn>
          </downloadexcel>
        </h1>
      
          
        <v-data-table
        :items="users"
        :headers="headers"
        >
            <template v-slot:item.created_at="{ item }">
                {{  prettyDate(item.created_at) }}
            </template>
            <template v-slot:item.age="{ item }">
                {{  getMetaValue(item.usermeta,'age') }}
            </template>
            <template v-slot:item.gender="{ item }">
                {{getMetaValue(item.usermeta,'gender')}}
            </template>
            <template v-slot:item.return_to_work="{ item }">
                <v-icon v-if="getMetaValue(item.usermeta,'return_to_work')" color="success">mdi-check</v-icon>
            </template>
            <template v-slot:item.return_to_education="{ item }">
                <v-icon v-if="getMetaValue(item.usermeta,'return_to_education')" color="success">mdi-check</v-icon>
            </template>
            <template v-slot:item.return_to_unsure="{ item }">
                <v-icon v-if="getMetaValue(item.usermeta,'return_to_unsure')" color="success">mdi-check</v-icon>
            </template>
            <template v-slot:item.industry_experience="{ item }">
                {{getCategories(item.usermeta,'industry_experience')}}
            </template>
            <template v-slot:item.industry_goals="{ item }">
                {{getCategories(item.usermeta,'industry_goals')}}
            </template>
            
            <template v-slot:item.contract_types="{ item }">
                <span class="mr-3" v-for="m in getMetaValue(item.usermeta,'contract_types')" :key="m.id">{{m.meta_value}}</span>
            </template>

        </v-data-table> 
      
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import { Link } from '@inertiajs/inertia-vue'
    import Layout from '@/Shared/VuetifyAdminLayout'
    import axios from 'axios'
    import downloadexcel  from "vue-json-excel";

  export default {
    components: {
      Head,
      downloadexcel,
      Link
    },
    props: {
      users: Array,
      categories: Array
      },
    /*computed: {
      reducedJobs() {
        let rj = JSON.parse(JSON.stringify(jobs));
        for(i=0;i<jobs.length;i++)
        {
          rj[i].organization_id = 
        }
      }
    },*/
    data: () => ({
      headers: [
        /*
        
User Email	User ID	First name	Last name	Username	Reg. Date	Age	Gender	Experience	Goals	Roles	CVs	Returning to...
Education	Work	Unsure
        */
              { text:'User ID', value:'id'},
              { text:'Email', value:'email'},
              { text:'Newsletter', value:'newsletter'},
              { text: 'First Name', value:'first_name'},
              { text: 'Last Name', value:'last_name'},
              { text: 'Reg. Date', value:'created_at'},
              { text: 'Age', value:'age'},
              { text: 'Gender', value:'gender'},
              { text: 'CVs', value:'resumes_count'},
              { text: 'Fav. Jobs', value:'favorite_jobs_count'},
              { text: 'App. Jobs', value:'applied_jobs_count'},
              { text: 'Fav. Courses', value:'favorite_courses_count'},
              { text: 'App. Courses', value:'applied_courses_count'},
              { text: 'Goals', value:'industry_goals'},
              { text: 'Experience', value:'industry_experience'},
              { text: 'Contract Types', value:'contract_types'},
              { text: 'Return to Work', value:'return_to_work'},
              { text: 'Return to Education', value:'return_to_education'},
              { text: 'Return to Unsure', value:'return_to_unsure'},
        ],
        user_fields: {
            "User ID": "id",
            "Newsletter":"newsletter",
            "Email":"email",
            "First Name": "first_name",
            "Last Name": "last_name",
            "Reg. Date": "created_at",


            "Age": {
                field: 'usermeta',
                callback: (value) => {
                    var result = value.filter(obj => {
                        return obj.meta_key === 'age'
                        });

                    if (result && result.length == 1)
                        return result[0].meta_value
                    else if (result && result.length > 1)
                        return result
                    else
                        return ''
                }
            },
            "Gender": {
                field: 'usermeta',
                callback: (value) => {
                    var result = value.filter(obj => {
                        return obj.meta_key === 'gender'
                        });

                    if (result && result.length == 1)
                        return result[0].meta_value
                    else if (result && result.length > 1)
                        return result
                    else
                        return ''
                }
            },
            "CVs":"resumes_count",
            "Fav. Jobs":"favorite_jobs_count",
            "App. Jobs":"applied_jobs_count",
            "Fav. Courses":"favorite_courses_count",
            "App. Courses":"applied_courses_count",
            "Goals":{
                field: 'usermeta',
                callback: (value) => {
                    return window.getCategories(value,'industry_goals')
                }
            },
            "Experience":{
                field: 'usermeta',
                callback: (value) => {
                    return window.getCategories(value,'industry_experience')
                }
            },
            "Contract Types": {
                field: 'usermeta',
                callback: (value) => {
                    let x = window.getMetaValue(value,'contract_types')
                    if (x && Array.isArray(x) && x.length > 1)
                        return x.map(x => x.meta_value).join();
                    else 
                        return x;
                }
            },
            "Return to Work":"return_to_work",
            "Return to Education":"return_to_education",
            "Return to Unsure":"return_to_unsure",
          
      },
    }),
    layout: Layout,
    created() {
        window.categories = this.categories;
        window.getCategories = this.getCategories
        window.getMetaValue = this.getMetaValue
    },
    methods: {
        prettyDate(x) {
            var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            return new Date(x).toLocaleDateString(undefined,options)
        },
      getMetaValue(m,key) {
        var result = m.filter(obj => {
            return obj.meta_key === key
            });

        if (result && result.length == 1)
            return result[0].meta_value
        else if (result && result.length > 1)
            return result
        else
            return ''
      },

      getCategories(m,key)
      {
        var result = m.filter(obj => {
            return obj.meta_key === key
            });
        
        if (result)
        {
            var t = "";
            for(var i =0; i<result.length;i++)
            {
                let cid = result[i].meta_value;
                var cat_names = this.categories.filter(obj=> {
                    return obj.id == cid
                    });
                if (cat_names && cat_names[0])
                    t+= cat_names[0].title + ' // ';
            }
            return t;
        }
        else
            return result
      }
      
    },
  }
  </script>
  
  <style scoped>
    .v-sheet--offset {
      top: -24px;
      position: relative;
    }
  </style>